import { ControlCodes } from '@bcube/shared/constants';
import {
  Building2,
  CreditCard,
  FileSignature,
  FileText,
  Package,
  ShoppingCart,
  TableProperties,
  Users,
} from 'lucide-react';
import type { ModuleConfig } from './types';

export const commercialModule: ModuleConfig = {
  id: 'commercial',
  title: 'Módulo Comercial',
  description: 'Gestão de produtos, contas de clientes e propostas comerciais.',
  basePath: '/commercial',
  icon: ShoppingCart,
  navigation: [
    {
      name: 'Vendedores',
      pathname: '/commercial/salespersons',
      icon: <Users size={16} className="text-muted-foreground" />,
      code: ControlCodes.commercial_salesperson,
    },
    {
      name: 'Produtos',
      pathname: '/commercial/products',
      icon: <Package size={16} className="text-muted-foreground" />,
      code: ControlCodes.commercial_product,
    },
    {
      name: 'Contas',
      pathname: '/commercial/accounts',
      icon: <Building2 size={16} className="text-muted-foreground" />,
      code: ControlCodes.commercial_accounts,
    },
    {
      name: 'Propostas',
      pathname: '/commercial/proposals',
      icon: <FileText size={16} className="text-muted-foreground" />,
      code: ControlCodes.commercial_proposal,
    },
    {
      name: 'Tabela de Preços',
      pathname: '/commercial/price-tables',
      icon: <TableProperties size={16} className="text-muted-foreground" />,
      code: ControlCodes.commercial_price_table,
    },
    {
      name: 'Análise de Crédito',
      pathname: '/commercial/credit-analysis',
      icon: <CreditCard size={16} className="text-muted-foreground" />,
      code: ControlCodes.commercial_credit_analysis,
    },
    {
      name: 'Contratos',
      pathname: '/commercial/contracts',
      icon: <FileSignature size={16} className="text-muted-foreground" />,
      code: ControlCodes.commercial,
    },
  ],
  landingActions: [
    {
      title: 'Vendedores',
      href: '/commercial/salespersons',
      code: ControlCodes.commercial_salesperson,
      icon: Users,
      iconForeground: 'text-blue-700',
      iconBackground: 'bg-blue-50',
      description: 'Gerencie os vendedores e suas carteiras de clientes.',
    },
    {
      title: 'Produtos',
      href: '/commercial/products',
      code: ControlCodes.commercial_product,
      icon: Package,
      iconForeground: 'text-orange-700',
      iconBackground: 'bg-orange-50',
      description:
        'Gerencie o catálogo de produtos, incluindo preços, descrições e disponibilidade.',
    },
    {
      title: 'Contas',
      href: '/commercial/accounts',
      code: ControlCodes.commercial_accounts,
      icon: Building2,
      iconForeground: 'text-blue-700',
      iconBackground: 'bg-blue-50',
      description:
        'Administre as contas de clientes, dados cadastrais e histórico de relacionamento.',
    },
    {
      title: 'Propostas',
      href: '/commercial/proposals',
      code: ControlCodes.commercial_proposal,
      icon: FileText,
      iconForeground: 'text-green-700',
      iconBackground: 'bg-green-50',
      description: 'Crie e gerencie propostas comerciais, acompanhe status e conversões.',
    },
    {
      title: 'Tabela de Preços',
      href: '/commercial/price-tables',
      code: ControlCodes.commercial_price_table,
      icon: TableProperties,
      iconForeground: 'text-purple-700',
      iconBackground: 'bg-purple-50',
      description: 'Gerencie tabelas de preços, configure valores e condições comerciais.',
    },
    {
      title: 'Análise de Crédito',
      href: '/commercial/credit-analysis',
      code: ControlCodes.commercial_credit_analysis,
      icon: CreditCard,
      iconForeground: 'text-indigo-700',
      iconBackground: 'bg-indigo-50',
      description: 'Acompanhe e gerencie análises de crédito de clientes.',
    },
    {
      title: 'Contratos',
      href: '/commercial/contracts',
      code: ControlCodes.commercial,
      icon: FileSignature,
      iconForeground: 'text-teal-700',
      iconBackground: 'bg-teal-50',
      description: 'Gerencie contratos padrão e contratos por cliente.',
    },
  ],
};
